import { formatUnit } from "@/lib/formatUnit";

const exact = (v) => (v == null ? "" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: 6 }));

/** Oct 16 2026: the request now carries SAP's own figure (to 3 decimals), so
 *  this flag explains the whole-unit DEFAULT the store's Issue Qty starts
 *  from - 0.512 of a pallet is asked for, 1 is what physically gets issued,
 *  and the store can edit that. It also keeps SAP's full-precision number
 *  visible when it runs past 3 decimals (0.000462963 of a corrugated set). */
export const RoundedUpFlag = ({ component, inline = false }) => {
  if (!component) return null;
  const unit = formatUnit(component.unit_of_measure || component.inventory_unit);
  const exactQty = component.required_qty_exact;
  const finerThanAsked = exactQty != null && component.required_qty != null
    && Math.abs(exactQty - component.required_qty) > 1e-9;
  if (!component.issue_rounded_up && !finerThanAsked) return null;
  const label = component.issue_rounded_up
    ? `issue ${exact(component.suggested_issue_qty)}`
    : `SAP ${exact(exactQty)}`;
  const title = component.issue_rounded_up
    ? `SAP needs ${exact(exactQty)} ${unit} for this run. It cannot be issued in fractions, so the store's Issue Qty starts at a whole ${unit || "unit"} and can be edited.`
    : `SAP's exact figure is ${exact(exactQty)} ${unit}.`;
  return (
    <span
      className={`${inline ? "ml-1.5" : "block"} text-[10px] font-normal text-[#B54708] whitespace-nowrap`}
      title={title}
      data-testid={`required-rounded-up-${component.product_id}`}
    >
      {label}
    </span>
  );
};
